export default function ProgressBar({progress}) {
    return (
       <div className="mt-4 bg-gray-300 rounded" style={{width:"66%"}}>
          <div
            className="bg-green-500 text-white text-sm text-center rounded"
            style={{ width: `${progress}%`,backgroundColor:'green' }}
          >
            {progress}%
          </div>
        </div>
    );
}